import React from 'react';
import Plot from 'react-plotly.js';

function PlotRenderer({ data, title}) {
    

    return (
        <Plot data={data}
                layout={{
                    title: {
                        text: title,
                        font: { color: 'white', size: 10 },
                        x: 0.5,
                        xanchor: 'center'
                    },
                    margin: { l: 20, r: 20, t: 30, b: 20 },
                    paper_bgcolor: 'rgba(0,0,0,0)',     // outer background transparent
                    plot_bgcolor: 'rgba(0,0,0,0)',      // inner chart area transparent
                    font: { color: 'white' },           // all text white
                    xaxis: { color: 'white', tickfont: { color: 'white' } },
                    yaxis: { color: 'white', tickfont: { color: 'white' } },
                    legend: {
                        orientation: 'h',   // horizontal layout
                        y: -0.2,             // position it below plot area
                        x: 0.5,
                        xanchor: 'center'
                    }
                }}
                useResizeHandler
                style={{ width: '100%', height: '350px' }}
                config={{ responsive: true }}
            />
    );
}

export default PlotRenderer;